var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c("h4", [_vm._v("Dimensions")]),
            _vm._v(" "),
            _c("h3", [_vm._v("Enter Total width & drop measurements")])
          ]),
          _vm._v(" "),
          _vm.$v.room.$error
            ? _c("v-flex", { attrs: { xs12: "" } }, [
                !_vm.$v.room.name.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Name")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.width.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Width")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.width.between && _vm.type != "Misc"
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter width between " +
                          _vm._s(_vm.$v.room.width.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.width.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.drop.required
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v("Please enter Drop")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$v.room.drop.between && _vm.type != "Misc"
                  ? _c("div", { staticClass: "red--text" }, [
                      _vm._v(
                        "Please enter drop between " +
                          _vm._s(_vm.$v.room.drop.$params.between.min) +
                          "mm and " +
                          _vm._s(_vm.$v.room.drop.$params.between.max) +
                          "mm"
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Name", v: _vm.$v.room.name },
                model: {
                  value: _vm.room.name,
                  callback: function($$v) {
                    _vm.$set(_vm.room, "name", $$v)
                  },
                  expression: "room.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Width", v: _vm.$v.room.width },
                on: { change: _vm.clearIndividualDimensions },
                model: {
                  value: _vm.room.width,
                  callback: function($$v) {
                    _vm.$set(_vm.room, "width", $$v)
                  },
                  expression: "room.width"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Drop", v: _vm.$v.room.drop },
                model: {
                  value: _vm.room.drop,
                  callback: function($$v) {
                    _vm.$set(_vm.room, "drop", $$v)
                  },
                  expression: "room.drop"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("h4", { staticClass: "mb-4" }, [_vm._v("Layout")]),
      _vm._v(" "),
      _vm.room.width
        ? _c("div", [
            _vm.room.width <= 6000
              ? _c(
                  "div",
                  { staticClass: "layout row wrap" },
                  [
                    _c(
                      "v-flex",
                      {
                        class: _vm.selectedOption === "LR" ? "elevation-2" : "",
                        attrs: { xs12: "", sm4: "", tile: "" },
                        on: {
                          click: function($event) {
                            return _vm.selectOption("LR")
                          }
                        }
                      },
                      [
                        _c("v-img", {
                          attrs: { src: "/static/LinkedAssets/LR-asset.jpg" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: _vm.selectedOption === "LL" ? "elevation-2" : "",
                        attrs: { xs12: "", sm4: "", tile: "" },
                        on: {
                          click: function($event) {
                            return _vm.selectOption("LL")
                          }
                        }
                      },
                      [
                        _c("v-img", {
                          attrs: { src: "/static/LinkedAssets/LL-asset.jpg" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: _vm.selectedOption === "RR" ? "elevation-2" : "",
                        attrs: { xs12: "", sm4: "", tile: "" },
                        on: {
                          click: function($event) {
                            return _vm.selectOption("RR")
                          }
                        }
                      },
                      [
                        _c("v-img", {
                          attrs: { src: "/static/LinkedAssets/RR-asset.jpg" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "layout row wrap m0a width90" },
              [
                _c(
                  "v-flex",
                  {
                    class: _vm.selectedOption === "LLL" ? "elevation-2" : "",
                    attrs: { xs12: "", sm6: "", tile: "" },
                    on: {
                      click: function($event) {
                        return _vm.selectOption("LLL")
                      }
                    }
                  },
                  [
                    _c("v-img", {
                      attrs: { src: "/static/LinkedAssets/LLL-asset.jpg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    class: _vm.selectedOption === "RRR" ? "elevation-2" : "",
                    attrs: { xs12: "", sm6: "", tile: "" },
                    on: {
                      click: function($event) {
                        return _vm.selectOption("RRR")
                      }
                    }
                  },
                  [
                    _c("v-img", {
                      attrs: { src: "/static/LinkedAssets/RRR-asset.jpg" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "layout row wrap" },
              [
                _c(
                  "v-flex",
                  {
                    class: _vm.selectedOption === "LRR" ? "elevation-2" : "",
                    attrs: { xs12: "", sm6: "", tile: "" },
                    on: {
                      click: function($event) {
                        return _vm.selectOption("LRR")
                      }
                    }
                  },
                  [
                    _c("v-img", {
                      attrs: { src: "/static/LinkedAssets/LRR-asset.jpg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  {
                    class: _vm.selectedOption === "LLR" ? "elevation-2" : "",
                    attrs: { xs12: "", sm6: "", tile: "" },
                    on: {
                      click: function($event) {
                        return _vm.selectOption("LLR")
                      }
                    }
                  },
                  [
                    _c("v-img", {
                      attrs: { src: "/static/LinkedAssets/LLR-asset.jpg" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedOption
        ? _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("h4", [_vm._v("Individual dimensions")]),
              _vm._v(" "),
              _vm.selectedOption === "LL"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l1", $$v)
                                  },
                                  expression: "easyLink.l1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "L2",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.l2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l2", $$v)
                                  },
                                  expression: "easyLink.l2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "LR"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l1", $$v)
                                  },
                                  expression: "easyLink.l1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "R2",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.r2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r2", $$v)
                                  },
                                  expression: "easyLink.r2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "RR"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "R1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.r1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r1", $$v)
                                  },
                                  expression: "easyLink.r1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "R2",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.r2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r2", $$v)
                                  },
                                  expression: "easyLink.r2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "LLL"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l1", $$v)
                                  },
                                  expression: "easyLink.l1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L2" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l2", $$v)
                                  },
                                  expression: "easyLink.l2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "L3",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.l3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l3", $$v)
                                  },
                                  expression: "easyLink.l3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "RRR"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "R1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.r1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r1", $$v)
                                  },
                                  expression: "easyLink.r1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "R2" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.r2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r2", $$v)
                                  },
                                  expression: "easyLink.r2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "R3",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.r3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r3", $$v)
                                  },
                                  expression: "easyLink.r3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "LLR"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l1", $$v)
                                  },
                                  expression: "easyLink.l1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L2" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l2", $$v)
                                  },
                                  expression: "easyLink.l2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "R3",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.r3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r3", $$v)
                                  },
                                  expression: "easyLink.r3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedOption === "LRR"
                ? _c(
                    "v-flex",
                    { attrs: { row: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("L")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "L1" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.l1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "l1", $$v)
                                  },
                                  expression: "easyLink.l1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: { type: "number", label: "R2" },
                                on: { input: _vm.autoFillLastDimension },
                                model: {
                                  value: _vm.easyLink.r2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r2", $$v)
                                  },
                                  expression: "easyLink.r2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm3: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [_c("h3", [_vm._v("R")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                background: "#abc",
                                "border-right": "0.5px solid #fff"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "vh" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                "border-right": "0.5px solid #fff",
                                "border-top": "2px solid #222"
                              },
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("span", { staticClass: "blur" }, [
                                _vm._v("aaaaaaaaaa aaaaaaaaa aaaaaaaaa")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                "pa-0": "",
                                "text-lg-center": ""
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  label: "R3",
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.easyLink.r3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.easyLink, "r3", $$v)
                                  },
                                  expression: "easyLink.r3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showErr
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { color: "red", "margin-top": "-48px" },
                      attrs: { xs12: "", sm12: "" }
                    },
                    [
                      _vm._v(
                        "\n        All Individual dimensions should be between 0 to 3000.\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02352cc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02352cc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/LinkedDimensionSelector.vue
// module id = null
// module chunks = 